/**
=========================================================
* E4A-IoT-Manager React Frontend Dashboard 
* Copyright © 2024 Electronics4All Inc.
=========================================================
*/
// React hooks and part code management service
import { useState, useEffect } from "react";

// MUI and Material Dashboard Components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import MDBox from "components/MDBox";

import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Checkbox from "@mui/material/Checkbox";


export default function FiltersDialog({
    handleClose,
    open,
    submit
}) {
    const [openCollapse, setOpenCollapse] = useState(false); // Opend the locations collapse
    const [Locations, setLocations] = useState(['Kanata', 'Smith Falls']); // Stores the selected locations

    // Debugger for Locations (Logs all checked locations)
    useEffect(() => { console.log(Locations) }, [Locations]);

    // Handles Locations Category Collapse
    const handleClick = () => {
        setOpenCollapse(!openCollapse);
    };

    // Handles Locations checkboxes
    const handleToggle = (value) => () => {
        const currentIndex = Locations.indexOf(value);
        const newLocations = [...Locations];

        if (currentIndex === -1) {
            newLocations.push(value);
        } else {
            newLocations.splice(currentIndex, 1);
        }

        setLocations(newLocations);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
        >
            <DialogTitle>Add Filters</DialogTitle>
            <DialogContent>
                <MDBox >

                    <List
                        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Inventory Filters
                            </ListSubheader>
                        }
                    >   {/* Locations */}
                        <ListItemButton onClick={handleClick} sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <WarehouseIcon />
                            </ListItemIcon>
                            <ListItemText primary="Warehouses" />
                            {openCollapse ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>

                                {/* Kanata */}
                                <ListItemButton sx={{ pl: 4 }} onClick={handleToggle('Kanata')}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            disableRipple
                                            checked={Locations.includes('Kanata')}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Kanata" />
                                </ListItemButton>

                                {/* Smith Falls */}
                                <ListItemButton sx={{ pl: 4 }} onClick={handleToggle('Smith Falls')}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            disableRipple
                                            checked={Locations.includes('Smith Falls')}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Smith Falls" />
                                </ListItemButton>

                            </List>
                        </Collapse>

                    </List>

                </MDBox>
            </DialogContent>
            <DialogActions>

                <Button onClick={handleClose}> Cancel </Button>
                <Button onClick={() => submit(Locations)}> Apply Filters </Button>

            </DialogActions>
        </Dialog>
    )
}